import React, { Component } from 'react';
import { FaCheck, FaTimes } from 'react-icons/fa';

class PasswordListItem extends Component {
  render() {
    const { passwordCondition, label } = this.props;
    return (
      <li style={{ color: passwordCondition ? 'green' : '#d32f2f' }}>{/* #d32f2f is the default error color of mui*/}
        {passwordCondition ? <FaCheck aria-hidden="true" /> : <FaTimes aria-hidden="true" />} {label}
      </li>
    );
  }
}

export default PasswordListItem;
